import {
	Container,
	Row,
	Col,
	InputGroup,
	FormControl,
	Button,
	Card,
	Image,
	Modal,
	Form,
	Accordion,
	Badge,
	Carousel,
	Dropdown
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faSlidersH, faChevronLeft, faChevronRight, faLocationDot, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import styles from '../styles/BrowseJobs.module.scss'
import JobDetails from '../components/JobDetails'
import ClickToView from '../components/ClickToView'
import { useState, useEffect } from 'react'
import { withIronSessionSsr } from 'iron-session/next'
import { sessionOptions } from '../lib/session'
import { createClient } from 'graphqurl'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'
import Head from 'next/head'
import FindjobsSidebar from '../components/sidebar/Findjobs'
import NTUCSidebar from '../components/sidebar/NTUC'
import Trie from '../lib/Trie'

const BrowseJobs = (props) => {
	const router = useRouter()
	const locale: string = router.locale as string
	const { t } = useTranslation()
	const { filters, Occupation, Category, mrtLine, MrtStation, jobs, Company, jobAggregate, redirectedFromMPS, state, city } = props

	const lmUnitedBanners = [
		{
			type: 'image',
			url: '/img/lmu/meet_coach_banner.png',
			link: 'https://eappt.e2i.com.sg',
			poster: ''
		},
		{
			type: 'image',
			url: '/img/lmu/tg_banner.png',
			link: 'https://t.me/findjobs01',
			poster: ''
		},
		{
			type: 'image',
			url: '/img/lmu/job_match_assistance.png',
			link: 'https://e2i.com.sg/events/',
			poster: ''
		},
		{
			type: 'image',
			url: '/img/lmu/booter_workshops.png',
			link: 'https://e2i.com.sg/individuals/employability/win-the-job/',
			poster: ''
		}
	]

	const mobileBanners = process.env.NEXT_PUBLIC_SITE_NAME === 'findjobs' ? props.mobileAdsOnCurrentPage : (process.env.NEXT_PUBLIC_SITE_NAME === 'ntuc' ? lmUnitedBanners : [])

	const popUpBanners = process.env.NEXT_PUBLIC_SITE_NAME === 'findjobs' ? props.popUpBanners : (process.env.NEXT_PUBLIC_SITE_NAME === 'ntuc' ? lmUnitedBanners : [])

	const slugify = (str) => {
		const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
		const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
		const p = new RegExp(a.split('').join('|'), 'g')

		return str.toString().toLowerCase()
			.replace(/\s+/g, '-') // Replace spaces with -
			.replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
			.replace(/&/g, '-and-') // Replace & with 'and'
			.replace(/[^\w\-]+/g, '') // Remove all non-word characters
			.replace(/\-\-+/g, '-') // Replace multiple - with single -
			.replace(/^-+/, '') // Trim - from start of text
			.replace(/-+$/, '') // Trim - from end of text
	}

	const [JD, setJD] = useState<any>(null)
	const viewJobDetails = async (j) => {
		// setJD(j)

		// Fetch data from external API for job details
		let apiUrl = `${process.env.NEXT_PUBLIC_API_ENDPOINT}v1/jobseeker/job/${j.id}?recommendation=none`
		if (typeof router.query.utm_source !== 'undefined') {
			apiUrl += `&utm_source=${router.query.utm_source}`
		}
		if (typeof router.query.utm_medium !== 'undefined') {
			apiUrl += `&utm_medium=${router.query.utm_medium}`
		}
		if (typeof router.query.utm_campaign !== 'undefined') {
			apiUrl += `&utm_campaign=${router.query.utm_campaign}`
		}

		const res = await fetch(apiUrl)
		const Job = await res.json()

		Job.Mrt = Job.JobLocations.filter((jl: any) => {
			return jl.MrtStation !== null
		})

		Job.City = Job.JobLocations.filter((jl: any) => {
			return jl.City !== null
		})

		Job.JobLocations = Job.JobLocations.filter((jl: any) => {
			return jl.Branch !== null
		})
		setJD(Job)

		const id = 'jobDetails'
		const yOffset = -12
		const element = document.getElementById(id)
		if (element !== null) {
			const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
			if (fixTop || showFooter) window.scrollTo({ top: y, behavior: 'smooth' })
		}

		if (window.innerWidth < 768) {
			const url = `/${router.locale}/job/${slugify(j.title)}-${j.id}`
			window.open(url, '_blank')?.focus()
		}
	}

	useEffect(() => {
		viewJobDetails(jobs[0])
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [router.isReady])

	// Keyword search
	const [keyword, setKeyword] = useState(filters.keyword)
	const search = (e) => {
		e.stopPropagation()
		e.preventDefault()
		window.location.href = getCurrentLinkWoPage()
	}

	// MRT Filter
	const [showMrtFilterModal, setShowMrtFilterModal] = useState(false)
	const [mrtFilterKeyword, setMrtFilterKeyword] = useState('')
	const [filterMrtLine, setFilterMrtLine] = useState(mrtLine)
	const [selectedMrt, setSelectedMrt] = useState(filters.mrt)
	const [selectedMrtLine, setSelectedMrtLine] = useState<any[]>([])

	// On mrt search
	const handleSearchMrt = (e) => {
		const validate = (e.target.value).replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
		setMrtFilterKeyword(validate)
		setFilterMrtLine(
			mrtLine.map((mrtL) => {
				return {
					colour: mrtL.colour,
					id: mrtL.id,
					name: mrtL.name,
					MrtStations: mrtL.MrtStations.filter((mrtS) => {
						return mrtS.name.toLowerCase().indexOf(validate.toLowerCase()) > -1
					})
				}
			})
		)
	}

	function isAllMrtChecked(arr, values) {
		return values.every(value => {
			return arr.includes(value)
		})
	}

	const mrtSelection = (e, mrtLineId) => {
		const tempSelectedMrt = Array.from(selectedMrt)
		if (typeof e.target !== 'undefined') {
			const value = e.target.value
			if (tempSelectedMrt.includes(value)) {
				tempSelectedMrt.splice(tempSelectedMrt.indexOf(value), 1)
			} else {
				tempSelectedMrt.push(value)
			}
			const filteredArr = tempSelectedMrt.filter(ele => (ele !== 'others' && ele !== 'multiple'))
			setSelectedMrt(filteredArr)
		} else if (e === 'others') {
			if (!selectedMrt.includes('others')) setSelectedMrt(['others'])
			else setSelectedMrt([])
		} else {
			if (!selectedMrt.includes('multiple')) setSelectedMrt(['multiple'])
			else setSelectedMrt([])
		}

		const index = mrtLine.findIndex(mrtl => mrtl.id === mrtLineId)
		let mrtstation = mrtLine[index].MrtStations
		mrtstation = mrtstation.map((mrts) => mrts.id)

		if(isAllMrtChecked(tempSelectedMrt, mrtstation)) {
			setSelectedMrtLine(selectedMrt => [...selectedMrt, mrtLineId])
		} else {
			setSelectedMrtLine(selectedMrtLine.filter(item => item !== mrtLineId))
		}
	}

	const selectAllMrt = (e) => {
		const value = e.target.value

		const currentMrtLine = mrtLine.filter((mrtl) => { return mrtl.id === value })[0]
		const currentMrtStationId = currentMrtLine.MrtStations.map((mrts) => { return mrts.id })

		if (e.target.checked === true) {
			const tempArr = [...new Set([...selectedMrt, ...currentMrtStationId])]
			const filteredArr = tempArr.filter(ele => ele !== 'others')
			setSelectedMrt(filteredArr)
			setSelectedMrtLine(selectedMrt => [...selectedMrt, value])
		} else {
			setSelectedMrt(selectedMrt.filter((smrt) => {
				return currentMrtStationId.includes(smrt) === false || smrt === 'others'
			}))
			setSelectedMrtLine(selectedMrtLine.filter(function(e) { return e !== value }))
		}
	}

	// MRT Filter
	const [showCityFilterModal, setShowCityFilterModal] = useState(false)
	const [cityFilterKeyword, setCityFilterKeyword] = useState('')
	const [filterState, setFilterState] = useState(state)
	const [selectedCity, setSelectedCity] = useState(filters.city)
	const [selectedState, setSelectedState] = useState<any[]>([])

	function isAllCityChecked(arr, values) {
		return values.every(value => {
			return arr.map(Number).includes(value)
		})
	}

	// On mrt search
	const handleSearchCity = (e) => {
		const validate = (e.target.value).replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
		setCityFilterKeyword(validate)
		setFilterState(
			state.map((st) => {
				return {
					id: st.id,
					name: st.name,
					Cities: st.Cities.filter((city) => {
						return city.name.toLowerCase().indexOf(validate.toLowerCase()) > -1
					})
				}
			})
		)
	}

	const citySelection = (e, stateId) => {
		let tempSelectedCity = Array.from(selectedCity)

		if (typeof e.target !== 'undefined') {
			const value = e.target.value
			if (tempSelectedCity.includes(value)) {
				tempSelectedCity.splice(tempSelectedCity.indexOf(value), 1)
			} else {
				tempSelectedCity.push(value)
			}
			const filteredArr = tempSelectedCity.filter(ele => (ele !== 'others' && ele !== 'multiple'))
			setSelectedCity(filteredArr)
		} else if (e === 'others') {
			if (!selectedCity.includes('others')) setSelectedCity(['others'])
			else setSelectedCity([])
		} else {
			if (!selectedCity.includes('multiple')) setSelectedCity(['multiple'])
			else setSelectedCity([])
		}

		const index = state.findIndex(st => st.id === stateId)
		let cities = state[index].Cities
		cities = cities.map((ct) => ct.id)
		tempSelectedCity = tempSelectedCity.map(Number)

		if(isAllCityChecked(tempSelectedCity, cities)) {
			setSelectedState(selectedCity => [...selectedCity, stateId.toString()])
		} else {
			setSelectedState(selectedState.filter(item => item !== stateId.toString()))
		}
	}

	const selectAllCity = (e) => {
		const value = e.target.value

		const currentState = state.filter((st) => { return st.id === parseInt(value) })[0]
		const currentCityId = currentState.Cities.map((city) => { return city.id.toString() })

		if (e.target.checked === true) {
			const tempArr = [...new Set([...selectedCity, ...currentCityId])]
			const filteredArr = tempArr.filter(ele => ele !== 'others')
			setSelectedCity(filteredArr)
			setSelectedState(selectedCity => [...selectedCity, value])
		} else {
			setSelectedCity(selectedCity.filter((city) => {
				return currentCityId.includes(city) === false || city === 'others'
			}))
			setSelectedState(selectedState.filter(function(e) { return e !== value }))
		}
	}

	useEffect(() => {
		if(locale.toUpperCase() === 'MY') {
			state.map((st) => {
				if(isAllCityChecked(selectedCity, st.Cities.map((ct) => ct.id))) {
					setSelectedState(selectedState => [...selectedState, st.id.toString()])
				}
			})
		}

		if(locale.toUpperCase() === 'SG') {
			mrtLine.map((mrt) => {
				if(isAllMrtChecked(selectedMrt, mrt.MrtStations.map((mrts) => mrts.id))) {
					setSelectedMrtLine(selectedMrtLine => [...selectedMrtLine, mrt.id])
				}
			})
		}
	}, [locale, mrtLine, selectedCity, selectedMrt, state])




	const selectAllCategory = (e) => {
		// const value = e.target.value
		const allCategoryId = Category.map((ind) => { return ind.id })
		if (e.target.checked === true) {
			setSelectedCategory([...new Set([...selectedCategory, ...allCategoryId])])
		} else {
			setSelectedCategory([])
		}
	}

	const selectAllOccupation = (e) => {
		// const value = e.target.value
		const allOccupationId = Occupation.map((occup) => { return occup.id })
		if (e.target.checked === true) {
			setSelectedOccupation([...new Set([...selectedOccupation, ...allOccupationId])])
		} else {
			setSelectedOccupation([])
		}
	}

	const selectCategory = (e) => {
		const tempSelectedCategory = Array.from(selectedCategory)
		const value = parseInt(e.target.value)
		if (tempSelectedCategory.includes(value)) {
			tempSelectedCategory.splice(tempSelectedCategory.indexOf(value), 1)
		} else {
			tempSelectedCategory.push(value)
		}
		setSelectedCategory(tempSelectedCategory)
	}

	const selectOccupation = (e) => {
		const tempSelectedOccupation = Array.from(selectedOccupation)
		const value = parseInt(e.target.value)
		if (tempSelectedOccupation.includes(value)) {
			tempSelectedOccupation.splice(tempSelectedOccupation.indexOf(value), 1)
		} else {
			tempSelectedOccupation.push(value)
		}
		setSelectedOccupation(tempSelectedOccupation)
	}

	const submitFilter = () => {
		window.location.href = getCurrentLinkWoPage()
	}

	// Job filter (occupation and industry)
	const [showJobFilterModal, setShowJobFilterModal] = useState(false)
	const [selectedCategory, setSelectedCategory] = useState(filters.category.map(x => parseInt(x)))
	const [selectedOccupation, setSelectedOccupation] = useState(filters.occupation.map(x => parseInt(x)))
	const [selectedJobType, setSelectedJobType] = useState(filters.jobType.length > 0 ? filters.jobType : [])

	const updateSelectedJobType = (type) => {
		const tempJobType = Array.from(selectedJobType)
		if (tempJobType.includes(type)) {
			tempJobType.splice(tempJobType.indexOf(type), 1)
		} else {
			tempJobType.push(type)
		}
		setSelectedJobType(tempJobType)
	}

	const getJobTypeText = (jt) => {
		return (jt === 'FT' ? t('job_descrip.ft') : (jt === 'PT' ? t('job_descrip.pt') : t('job_descrip.con')))
	}

	const getSalTyp = (val) => {
		switch (val) {
		case 'PER DAY':
			return t('root.day')
		case 'PER HOUR':
			return t('root.hour')
		case 'PER MONTH':
			return t('root.month')
		case 'PER WEEK':
			return t('root.week')
		default:
			return t('root.month')
		}
	}

	const getRespectiveJobTitle = (job) => {
		return job.title
	}

	const [fixTop, setFixTop] = useState(false)
	const [jobDetailHeight, setJobDetailHeight] = useState<number>(0)
	const [showFooter, setShowFooter] = useState(false)

	const getShowPopup = (): any => {
		if (typeof localStorage !== 'undefined' && process.env.NEXT_PUBLIC_SITE_NAME as string !== 'wcgrc') {
			const popUp: string = localStorage.getItem('popUp') as string
			// localStorage.setItem('popUp', new Date().toString())
			if (typeof popUp !== 'undefined') {
				const currentDate = new Date(Date.now())
				const savedDate = new Date(popUp)
				if (currentDate.getFullYear() === savedDate.getFullYear() && currentDate.getMonth() === savedDate.getMonth() && currentDate.getDate() === savedDate.getDate()) {
					return false
				} else {
					return true
				}
			} else {
				return true
			}
		} else if (process.env.NEXT_PUBLIC_SITE_NAME as string === 'wcgrc') {
			return false
		} else {
			return true
		}
	}

	const [showPopup, setShowPopup] = useState(false)
	const [keyphraseTrie, setKeyphraseTrie] = useState(new Trie())
	const [typeAhead, setTypeAhead] = useState<any[]>([])
	const [showTypeAhead, setShowTypeAhead] = useState<boolean>(true)

	const typeAheadSearch = async () => {
		const trie = keyphraseTrie
		const res = await fetch(`${process.env.NEXT_PUBLIC_API_ENDPOINT}v1/jobseeker/job/type-ahead-search`)
		const keyphrase = await res.json()
		for (const k of keyphrase) {
			const kSplit = k.split(',')
			trie.insert(kSplit[0], kSplit[1])
		}
		setKeyphraseTrie(trie)
	}

	const selectKeyphrase = (k) => {
		window.location.href = getCurrentLinkWoPage(k[0])
	}

	useEffect(() => {
		return setTypeAhead(keyword ? keyphraseTrie.find(keyword.toLowerCase()) : [])
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [keyword])

	useEffect(() => {
		// setShowPopup(getShowPopup() || props.redirectedFromMPS)
		setShowPopup(true)

		// Get keyphrase for type ahead search
		typeAheadSearch()

	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [router.isReady, props.redirectedFromMPS])

	useEffect(() => {
		if (showPopup) {
			localStorage.setItem('popUp', new Date().toString())
		}
	}, [showPopup])

	const updateShowPopup = (): void => {
		setShowPopup(false)
		localStorage.setItem('popUp', new Date().toString())
	}

	useEffect(() => {
		const onScroll = () => {
			const height = document.getElementsByTagName('html')[0].offsetHeight - window.pageYOffset - window.innerHeight
			const jobDetailsHeight = window.document.getElementById('jobDetails')
			if (jobDetailsHeight !== null) setJobDetailHeight(jobDetailsHeight.offsetHeight)
			setShowFooter(height < 50)
			if (window.pageYOffset > 160 && window.innerWidth > 768 && height > 50) {
				setFixTop(true)
			} else {
				setFixTop(false)
			}
		}
		// clean up code
		window.removeEventListener('scroll', onScroll)
		window.addEventListener('scroll', onScroll, { passive: true })
		return () => window.removeEventListener('scroll', onScroll)
	}, [router.isReady])

	const validateAndEncode = (str) => {
		const validate = str.replace(/[`~!@#$%^*()_|+\-=?;:'".<>\{\}\[\]\\\/]/gi, '')
		return encodeURIComponent(validate)
	}

	const getCurrentLinkWoPage = (customKeyword = null) => {
		const userInput = keyword !== '' ? 'keyword=' + validateAndEncode(customKeyword ? customKeyword : keyword) + '&' : ''
		const city = selectedCity.length > 0 ? 'city=' + selectedCity.join(',') + '&' : ''
		const mrt = selectedMrt.length > 0 ? 'mrt=' + selectedMrt.join(',') + '&' : ''
		return `/${router.locale}/browse-jobs?${props.filters.layout !== '' ? 'layout=' + props.filters.layout + '&' : ''}${userInput}${router.locale === 'sg' ? mrt : ''}${selectedCategory.length > 0 ? 'category=' + selectedCategory.join(',') + '&' : ''}${selectedOccupation.length > 0 ? 'occupation=' + selectedOccupation.join(',') + '&' : ''}${selectedJobType.length > 0 ? 'jobType=' + selectedJobType.join(',') + '&' : ''}${router.locale === 'my' ? city : ''}`
	}

	const getPaginationLink = (page) => {
		if (router.query.company) {
			return `/browse-jobs?company=${router.query.company}&page=${page}`
		} else {
			return `${getCurrentLinkWoPage()}&page=${page}`
		}
	}

	return (
		<>
			<Head>
				<title>Find Jobs Easily</title>
				<meta name='description' content='Looking for a job? In collaboration with e2i, South East Community Development Council (CDC) has curated a jobs portal for you, start browsing today and embark on your new career!' />
			</Head>
			{/* <Row className='mt-2'>
				<Col>
					<h2>{t('job_list.welcome_to_findjobs')}</h2>
				</Col>
			</Row>
			<br />
			Removed the welcome to find jobs message*/}
			<Form onSubmit={search}>
				<Row>
					<Col className={styles.no_padding_right_on_desktop}>
						<InputGroup className="mb-2">
							<InputGroup.Text id="basic-addon1" className={styles.inputGroupText}>
								<FontAwesomeIcon icon={faSearch} />
							</InputGroup.Text>
							<FormControl
								className={styles.input}
								placeholder={t('job_list.Search_by_keyword')}
								aria-label={t('job_list.Search_by_keyword')}
								aria-describedby={t('job_list.Search_by_keyword')}
								style={{ borderTopRightRadius: '15px', borderBottomRightRadius: '15px' }}
								value={keyword}
								size='lg'
								onChange={(e) => { setKeyword(e.target.value) }}
								onFocus={() => { setShowTypeAhead(true) }}
								onBlur={(e) => {
									setShowTypeAhead(e?.relatedTarget?.className === 'dropdown-item' ? true : false)
								}}
							/>
							<Dropdown.Menu rootCloseEvent='click' show={(typeAhead.length > 0 && showTypeAhead)} style={{ marginTop: '50px', borderRadius: '15px', width: '100%' }}>
								{typeAhead.map((th, i) => {
									return <Dropdown.Item onClick={() => {
										selectKeyphrase(th)
									}} key={i} eventKey={i} style={{ fontWeight: '600' }}>{th[0]}</Dropdown.Item>
								})}
							</Dropdown.Menu>
						</InputGroup>
					</Col>
					<Col xs={12} md='auto' className='text-white'>
						<div>
							{/* <Button type='submit' variant='primary' size='lg' className={`${styles.btn_pl_pr} text-white text-weight-bold`}>
              Search
							</Button> {' '} &nbsp;&nbsp; */}
							{
								router?.locale?.toUpperCase() === 'SG' ? (
									<Button type='button' variant='primary' size='lg' className='text-white text-weight-bold me-2' onClick={() => { setShowMrtFilterModal(true) }}>
										<FontAwesomeIcon icon={faLocationDot} /> {' '} MRT
									</Button>
								) : router?.locale?.toUpperCase() === 'MY' ? (
									<Button type='button' variant='primary' size='lg' className='text-white text-weight-bold me-2' onClick={() => { setShowCityFilterModal(true) }}>
										<FontAwesomeIcon icon={faLocationDot} /> {' '} City
									</Button>
								) : (
									<></>
								)
							}
							<Button type='button' variant='outline-primary' size='lg' className={styles.filter_btn} onClick={() => { setShowJobFilterModal(true) }}>
								<FontAwesomeIcon icon={faSlidersH} />
							</Button>
						</div>
					</Col>
				</Row>
			</Form>
			<Row>
				<Col>
					<div style={{ marginBottom: '12px' }}>
						{filters.keyword !== '' && <Badge pill bg='primary'>{filters.keyword}</Badge>}
						{selectedCategory.length > 0 &&
							Category.filter((ind) => { return filters.category.indexOf(ind.id.toString()) !== -1 }).map((ind, i) => {
								return i < 2 ? <Badge pill bg='primary' key={i}>{ind.name}</Badge> : ''
							})}
						{filters.category.length > 2 && <span> ... </span>}
						{selectedOccupation.length > 0 &&
							Occupation.filter((occup) => { return filters.occupation.indexOf(occup.id.toString()) !== -1 }).map((occup, i) => {
								return i < 2 ? <Badge pill bg='primary' key={i}>{occup.name}</Badge> : ''
							})}
						{filters.occupation.length > 2 && <span> ... </span>}
						{selectedMrt.length === 1 && selectedMrt[0] === 'others' && <Badge pill bg='primary'>Outside SE</Badge>}
						{selectedMrt.length === 1 && selectedMrt[0] === 'multiple' && <Badge pill bg='primary'>Multiple locations</Badge>}
						{selectedMrt.length > 0 &&
							MrtStation.filter((mrts) => {
								return filters.mrt.indexOf(mrts.id.toString()) !== -1
							}).map((mrts, i) => {
								return i < 2 ? <Badge pill bg='primary' key={i}>{mrts.name}</Badge> : ''
							})
						}
						{filters.mrt.length > 2 && <span> ... </span>}
						{selectedCity.length > 0 &&
							city.filter((ct) => {
								return filters.city.indexOf(ct.id.toString()) !== -1
							}).map((ct, i) => {
								return i < 2 ? <Badge pill bg='primary' key={i}>{ct.name}</Badge> : ''
							})
						}
						{filters.city.length > 2 && <span> ... </span>}
						{selectedJobType.length > 0 &&
							selectedJobType.map((jt, i) => {
								const returnRespectiveString = () => {
									let string
									switch (jt) {
									case 'FT':
										string = 'job_application.ft'
										break
									case 'PT':
										string = 'job_application.pt'
										break
									case 'CONTRACT':
										string = 'job_descrip.con'
										break
									case 'seniorFriendly':
										string = 'filter.senior_friendly'
										break
									case 'pwd':
										string = 'filter.pwd'
										break
									}
									return string
								}
								return <Badge key={i} pill bg='primary'>{t(returnRespectiveString())}</Badge>
							})}
						{Company != null && <Badge pill bg='primary'>{Company[0].name}</Badge>}
						{(filters.keyword !== '' || selectedCategory.length > 0 || selectedOccupation.length > 0 || selectedCity.length > 0 || selectedMrt.length > 0 || selectedJobType.length > 0 || Company !== null) &&
							<Badge
								className='clickable' pill bg='danger' style={{ backgroundColor: 'red', color: 'white', cursor: 'pointer' }} onClick={() => { window.location.href = `/${router.locale}/browse-jobs` }}
							>{t('clear')}
							</Badge>}
					</div>
				</Col>
			</Row>
			<Row style={{ marginBottom: '-10px' }} className='gx-3'>
				<Col xs={12} md={3} lg={3}>
					<div
						className={`${fixTop ? 'fixed-top' : ''}`}
						style={{ zIndex: fixTop ? 0 : 'auto' }}
					>
						<Container
							className={fixTop ? '' : styles.no_fixed_top}
						>
							<Row>
								<Col
									xs={fixTop ? 3 : 12}
									className={fixTop ? styles.fixedTop : ''}
									style={{ paddingLeft: fixTop ? '0px' : '12px' }}
								>
									<Card>
										<Card.Body className={`${fixTop ? styles.fix_top_card_body : ''} p-0 mt-0`} style={showFooter && window.innerWidth > 768 ? { height: jobDetailHeight + 'px' } : {}}>
											<div style={{ height: '91%', overflow: 'auto' }}>
												{jobs.length <= 0 && (
													<div className='text-center p-5'>
														<Image src='/img/no-jobs-applied.png' alt='no-jobs' /><br /><br />
														<p><strong>{t('filter.no_jobs')}</strong></p>
														<p>{t('filter.try_diff_key')}<span style={{ color: 'orange', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => { window.location.href = `/${router.locale}/browse-jobs` }}>{t('filter.click_here')}</span>{t('filter.back_to_job_list')}</p>
														<br />
													</div>
												)}
												{/* mobile view jobs and banner */}
												{jobs.map((j, i) => {
													const bannerNum: number = (i / 2) - 1
													
													return <div key={i}>
														{(i % 2 === 0 && i !== 0 && typeof mobileBanners[bannerNum] !== 'undefined' && parseInt(process.env.NEXT_PUBLIC_SHOW_SIDEBAR as string) === 1) && (
															<div className='d-block d-sm-none'>
																{process.env.NEXT_PUBLIC_SITE_NAME === 'findjobs'
																	? (
																		mobileBanners[bannerNum].id != null
																			? (
																				<a target='_blank' rel='noreferrer' href={`/event/${mobileBanners[bannerNum].id as string}`}>
																					<Image src={mobileBanners[bannerNum].banner} alt='Banner' style={{ width: '100%' }} />
																				</a>
																			) : (
																				<a target='_blank' rel='noreferrer' href={mobileBanners[bannerNum].link}>
																					<Image src={mobileBanners[bannerNum].banner} alt='Banner' style={{ width: '100%' }} />
																				</a>
																			)

																	) : (
																		<a target='_blank' rel='noreferrer' href={mobileBanners[bannerNum].link}>
																			<Image src={mobileBanners[bannerNum].url} alt='Banner' style={{ width: '100%' }} />
																		</a>
																	)}
																<br /><br />
															</div>
														)}

														<div key={i} className={`${styles.job} 
														${JD && JD.id && JD.id == j.id ? (i == 0 ? styles.selectedJob_first : (i == jobs.length - 1 ? styles.selectedJob_last : styles.selectedJob)) : styles.jobInJobList}`} 
														onClick={() => { viewJobDetails(j) }}>

															{j.Company.avatar && <Image src={j.Company.avatar} alt='Company Logo' className='mt-3 mb-2' style={{ maxHeight: '50px' }} />}

															{!j.Company.avatar &&
															<div style={{ paddingTop: '20px' }}>
																<div style={{ border: '1px solid #eee', width: '50%', padding: '20px' }}>{j.Company.name}
																</div>
															</div>}

															<p className='mt-3 mb-0'><strong>{getRespectiveJobTitle(j)}</strong></p>

															<small>{j.Company.name}</small>

															<p className='mt-1'>
																<small style={{ fontWeight: '500', fontSize: '12px' }}>
																	{!j.hideSalaries && j.JobSalaries.map((js, i) => {
																		return (
																			<span key={i}>
																				<strong /> 
																				<span style={{ display: 'block' }} key={i}>
																					<small>{getJobTypeText(js.jobType)}</small> : 
																					<span style={{ fontWeight: 600 }}>
																						{js.min > 0 ? `${locale.toUpperCase() === 'SG' ? '$' : locale.toUpperCase() === 'MY' ? 'RM' : '$'} 
																					${js.min}` : ''} 
																						{js.min > 0 && js.max > 0 ? ' - ' : ''} 
																						{js.max > 0 ? `${locale.toUpperCase() === 'SG' ? '$' : locale.toUpperCase() === 'MY' ? 'RM' : '$'} ${js.max}` : ''}</span>
																					
																					<small> / {js.salaryType === null ? t('root.month') : getSalTyp(js.salaryType)}</small>
																				</span>
																			</span>
																		)
																	})}
																</small>
															</p>

														</div>
														{i < jobs.length - 1 && <hr className='my-0' />}
													</div>
												})}
											</div>
											{(jobs.length > 0 && jobAggregate > 10) &&
												<div className='justify-content-center text-center' style={{ marginTop: '0vh', backgroundColor: 'white', borderTop: '1px solid lightgray', paddingTop: '2.5vh', paddingBottom: '18px', borderBottomLeftRadius: '24px', borderBottomRightRadius: '24px' }}>
													<nav aria-label='Page navigation example'>
														<ul className='pagination justify-content-center pagination-sm'>
															<li className={props.pagination.prev ? 'page-item' : 'page-item disabled'}>
																<a className='page-link' href={getPaginationLink((parseInt(filters.page) - 1).toString())} aria-disabled='true'>
																	<FontAwesomeIcon icon={faChevronLeft} width='12px' />
																</a>
															</li>
															{props.pagination.pagi.map((pagi, index) => {
																return (
																	<li key={index} className={pagi === 'dotted' ? 'page-item disabled' : (pagi === parseInt(props.filters.page) ? 'page-item active' : 'page-item')}>
																		<a className='page-link' href={getPaginationLink(pagi.toString())}>{pagi === 'dotted' ? '...' : pagi}</a>
																	</li>
																)
															})}
															<li className={props.pagination.next ? 'page-item' : 'page-item disabled'}>
																<a className='page-link' href={getPaginationLink((parseInt(filters.page) + 1).toString())}>
																	<FontAwesomeIcon icon={faChevronRight} width='12px' />
																</a>
															</li>
														</ul>
													</nav>
												</div>}
										</Card.Body>
									</Card>
								</Col>
							</Row>
						</Container>
					</div>
				</Col>
				<Col
					className='d-none d-md-block'
					xs={12} md={parseInt(process.env.NEXT_PUBLIC_SHOW_SIDEBAR as string) === 1 ? 6 : 12}
				>
					<div id='jobDetails'>
						{JD !== null && <JobDetails job={JD} isFullPage={false} key={JD.id} />}
						{JD === null && <ClickToView />}
					</div>
				</Col>
				{parseInt(process.env.NEXT_PUBLIC_SHOW_SIDEBAR as string) === 1 && (
					<Col
						md={3}
						className='d-none d-sm-block'
						style={{ zIndex: fixTop ? 1 : 'auto' }}
					>
						{process.env.NEXT_PUBLIC_SITE_NAME === 'ntuc' && <NTUCSidebar />}
						{
							process.env.NEXT_PUBLIC_SITE_NAME !== 'ntuc' && locale.toUpperCase() === 'SG' ?
								<FindjobsSidebar adsAndEvents={props.adsAndEvents} locale={locale}/> :
								process.env.NEXT_PUBLIC_SITE_NAME !== 'ntuc' && locale.toUpperCase() === 'MY' ?
									<FindjobsSidebar adsAndEvents={props.malaysiaAds} locale={locale}/> :
									<FindjobsSidebar adsAndEvents={props.adsAndEvents} locale={locale} />
						}
					</Col>
				)}
			</Row>
			{/* <br /> */}

			{/* MRT filter */}
			<Modal size='lg' show={showMrtFilterModal} onHide={() => { setShowMrtFilterModal(false) }} className='bottom-modal'>
				<Modal.Body>
					<div>
						<Modal.Title className='text-center'>{t('filter.mrt')}</Modal.Title>
						<br />
						<Form.Control value={mrtFilterKeyword} type='text' placeholder={t('filter.search_by_mrt')} onChange={(e) => { handleSearchMrt(e) }} />
						<br />
						<div style={{ maxHeight: '60vh', overflow: 'auto' }}>
							<Accordion alwaysOpen>
								{filterMrtLine.map((mrtl, i) => {
									if (mrtl.MrtStations.length > 0) {
										const mrtIds = mrtl.MrtStations.map((st) => st.id.toString())

										return (
											<Accordion.Item eventKey={i.toString()} key={i}>
												<Accordion.Header>
													<span style={{ display: 'inline-block', padding: '3px 8px', borderRadius: '3px', backgroundColor: `${mrtl.colour}`, color: 'white', fontSize: '14px' }}>
														{mrtl.id.slice(0, -1)}
													</span> &nbsp; {mrtl.name}
													{
														mrtl.MrtStations.length === selectedMrt.filter(x => mrtIds.includes(x)).length ? <Badge pill bg='success' className='mx-2'>All MRT selected</Badge> : selectedMrt.filter(x => mrtIds.includes(x)).length !== 0 ? <Badge pill bg='info' className='mx-2'>{selectedMrt.filter(x => mrtIds.includes(x)).length} MRT selected</Badge> : ''
													}
												</Accordion.Header>
												<Accordion.Body >
													<Form.Check
														type='checkbox'
														id={`select-all-${mrtl.id}`}
														value={mrtl.id}
														label={t('sel_all')}
														onChange={(e) => {
															selectAllMrt(e)
														}}
														checked={selectedMrtLine.includes(mrtl.id)}
													/>
													{mrtl.MrtStations.map((mrts, j) => {
														return (
															<Form.Check
																checked={selectedMrt.includes(mrts.id)}
																key={`${i}-${j}`}
																value={mrts.id}
																type='checkbox'
																label={mrts.name}
																id={`mrt-station-${mrts.id}`}
																onChange={(e) => {
																	mrtSelection(e, mrtl.id)
																}}
															/>
														)
													})}
												</Accordion.Body>
											</Accordion.Item>
										)
									}
								})}
								<br />
								{/* <div className='px-1'>
									<Form.Check
										type='checkbox'
										id={t('job_list.other_loc')}
										label={t('job_list.other_loc')}
										onChange={() => mrtSelection('others')}
										checked={selectedMrt.includes('others')}
									/> */}
								{/* <Form.Check
										type='checkbox'
										id={t('job_list.multiple_locations')}
										label={t('job_list.multiple_locations')}
										onChange={() => mrtSelection('multiple')}
										checked={selectedMrt.includes('multiple')}
									/> */}
								{/* </div> */}
							</Accordion>
						</div>
						<br />
						<Row className='justify-content-center'>
							<Col md={4}>
								<br />
								<div className='d-grid gap-2'>
									<Button variant='primary' className='text-white' onClick={submitFilter}>{t('search')}</Button>
									<Button variant='link' className='text-decoration-none' onClick={() => { setShowMrtFilterModal(false) }}>{t('close')}</Button>
								</div>
							</Col>
						</Row>
					</div>
					<br />
				</Modal.Body>
			</Modal>

			{/* City filter */}
			<Modal size='lg' show={showCityFilterModal} onHide={() => { setShowCityFilterModal(false) }} className='bottom-modal'>
				<Modal.Body>
					<div>
						<Modal.Title className='text-center'>City</Modal.Title>
						<br />
						<Form.Control value={cityFilterKeyword} type='text' placeholder="Search by city" onChange={(e) => { handleSearchCity(e) }} />
						<br />
						<div style={{ maxHeight: '60vh', overflow: 'auto' }}>
							<Accordion alwaysOpen>
								{filterState.map((st, i) => {
									if (st.Cities.length > 0) {
										const cityIds = st.Cities.map((ct) => ct.id.toString())

										return (
											<Accordion.Item eventKey={i.toString()} key={i}>
												<Accordion.Header>
													{st.name} {
														st.Cities.length === selectedCity.filter(x => cityIds.includes(x)).length ? <Badge pill bg='success' className='mx-2'>All City selected</Badge> : selectedCity.filter(x => cityIds.includes(x)).length !== 0 ? <Badge pill bg='info' className='mx-2'>{selectedCity.filter(x => cityIds.includes(x)).length} City selected</Badge> : ''
													}
												</Accordion.Header>
												<Accordion.Body >
													<Form.Check
														type='checkbox'
														id={`select-all-${st.id}`}
														value={st.id}
														label={t('sel_all')}
														onChange={(e) => {
															selectAllCity(e)
														}}
														checked={selectedState.includes(st.id.toString())}
													/>
													{st.Cities.map((city, j) => {
														return (
															<Form.Check
																checked={selectedCity.includes(city.id.toString())}
																key={`${i}-${j}`}
																value={city.id}
																type='checkbox'
																label={city.name}
																id={`mrt-station-${city.id}`}
																onChange={(e) => {
																	citySelection(e, st.id)
																	if(!e.target.checked) {
																		setSelectedState(selectedState.filter(function(e) { return e !== st.id.toString() }))
																	}
																}}
															/>
														)
													})}
												</Accordion.Body>
											</Accordion.Item>
										)
									}
								})}
							</Accordion>
						</div>
						<br />
						<Row className='justify-content-center'>
							<Col md={4}>
								<br />
								<div className='d-grid gap-2'>
									<Button variant='primary' className='text-white' onClick={submitFilter}>{t('search')}</Button>
									<Button variant='link' className='text-decoration-none' onClick={() => { setShowCityFilterModal(false) }}>{t('close')}</Button>
								</div>
							</Col>
						</Row>
					</div>
					<br />
				</Modal.Body>
			</Modal>

			{/* Job filter */}
			<Modal show={showJobFilterModal} className='bottom-modal' size='lg' onHide={() => { setShowJobFilterModal(false) }}>
				<Modal.Body>
					<div>
						<Modal.Title className='text-center'>{t('filter.job_filter')}</Modal.Title>
						<br />
						<div style={{ maxHeight: '60vh', overflow: 'auto' }}>
							<Accordion alwaysOpen>
								<Accordion.Item eventKey="0">
									<Accordion.Header>{t('job_descrip.job_type')}</Accordion.Header>
									<Accordion.Body>
										<Form.Check
											checked={selectedJobType.includes('FT')}
											key='job-type-full-time'
											value='FT'
											type='checkbox'
											label={t('job_descrip.ft')}
											id='job-type-full-time'
											onChange={() => { updateSelectedJobType('FT') }}
										/>
										<Form.Check
											checked={selectedJobType.includes('PT')}
											key='job-type-part-time'
											value='PT'
											type='checkbox'
											label={t('job_descrip.pt')}
											id='job-type-part-time'
											onChange={() => { updateSelectedJobType('PT') }}
										/>
										<Form.Check
											checked={selectedJobType.includes('CONTRACT')}
											key='job-type-contract'
											value='CONTRACT'
											type='checkbox'
											label={t('job_descrip.con')}
											id='job-type-contract'
											onChange={() => { updateSelectedJobType('CONTRACT') }}
										/>
										{/*
										<Form.Check
											checked={selectedJobType.includes('seniorFriendly')}
											key='job-type-senior-friendly'
											value='senior-friendly'
											type='checkbox'
											label={t('filter.senior_friendly')}
											id='job-type-senior-friendly'
											onChange={() => { updateSelectedJobType('seniorFriendly') }}
										/>
										<Form.Check
											checked={selectedJobType.includes('pwd')}
											key='job-type-pwd'
											value='pwd'
											type='checkbox'
											label={t('filter.pwd')}
											id='job-type-pwd'
											onChange={() => { updateSelectedJobType('pwd') }}
										/> */}
									</Accordion.Body>
								</Accordion.Item>

								<Accordion.Item eventKey='1'>
									<Accordion.Header>Job Category</Accordion.Header>
									<Accordion.Body>
										<Form.Check
											type='checkbox'
											id='select-all-category'
											label={t('sel_all')}
											onChange={selectAllCategory}
										/>
										{Category.map((ind, j) => {
											return (
												<Form.Check
													checked={selectedCategory.includes(ind.id)}
													key={`ind-${j}`}
													value={ind.id}
													type='checkbox'
													label={ind.name}
													id={`ind-${ind.id}`}
													onChange={selectCategory}
												/>
											)
										})}
									</Accordion.Body>
								</Accordion.Item>
								<Accordion.Item eventKey='2'>
									<Accordion.Header>{t('filter.job_position')}</Accordion.Header>
									<Accordion.Body>
										<Form.Check
											type='checkbox'
											id='select-all-occupation'
											label={t('sel_all')}
											onChange={selectAllOccupation}
										/>
										{Occupation.map((occup, j) => {
											return (
												<Form.Check
													checked={selectedOccupation.includes(occup.id)}
													key={`occup-${j}`}
													value={occup.id}
													type='checkbox'
													label={occup.name}
													id={`occup-${occup.id}`}
													onChange={selectOccupation}
												/>
											)
										})}
									</Accordion.Body>
								</Accordion.Item>
							</Accordion>
						</div>
						<br /><br />
						<Row className='justify-content-center'>
							<Col md={4}>
								<div className='d-grid gap-2'>
									<Button variant='primary' className='text-white' onClick={submitFilter}>{t('search')}</Button>
									<Button variant='link' className='text-decoration-none' onClick={() => { setShowJobFilterModal(false) }}>{t('close')}</Button>
								</div>
							</Col>
						</Row>
					</div>
					<br />
				</Modal.Body>
			</Modal>

			{/* Popup */}
			{(typeof document !== 'undefined' && popUpBanners.filter((banner: any) => banner.featured).length > 0 && process.env.NEXT_PUBLIC_SITE_NAME !== 'ntuc') &&
				<Modal show={showPopup} onHide={() => setShowPopup(false)} size={redirectedFromMPS ? 'lg' : undefined}>
					<Button onClick={() => { updateShowPopup() }} style={{ backgroundColor: 'transparent', border: 'none', position: 'absolute', zIndex: 999, right: '0' }}>
						<FontAwesomeIcon style={{ width: '14px', color: 'black' }} icon={faTimesCircle} />
					</Button>
					<Modal.Body style={{ padding: '2px' }}>
						<Carousel indicators={false}>
							{redirectedFromMPS && (
								<Carousel.Item>
									<a target='_blank' rel='noreferrer' href='https://eappt.e2i.com.sg'>
										<Image
											className='d-block'
											style={{ width: '100%' }}
											src='/img/lmu/meet_coach_banner.png'
											alt=''
										/>
									</a>
								</Carousel.Item>
							)}
							{!redirectedFromMPS &&
								popUpBanners.filter((banner: any) => banner.featured).map((ban: any, i: number) => {
									return (
										<Carousel.Item key={i}>
											<a href={ban.type === 'Event' ? `/event/${ban.id as string}` : ban.param}>
												<Image
													width={100}
													className='d-block w-100'
													src={ban.banner}
													alt={ban.name}
												/>
											</a>
											{(ban.param !== null || ban.type === 'Event') && <div className="d-grid gap-2 p-3">
												<Button variant='primary' href={ban.type === 'Event' ? `/event/${ban.id as string}` : ban.param} target='_blank' rel='noreferrer' className='text-white'>Learn more</Button>
											</div>}
										</Carousel.Item>
									)
								})
							}
						</Carousel>
					</Modal.Body>
				</Modal>}
		</>
	)
}

export const getServerSideProps = withIronSessionSsr(async function getServerSideProps({ locale, query, req }) {
	let company = 0
	if (typeof query.company !== 'undefined') {
		company = parseInt(query.company as string)
	}
	const mrt = (typeof query.mrt !== 'undefined' ? query.mrt as string : '').replace(/[`~!@#$%^*()_|+\-=?;:'".<>\{\}\[\]\\\/]/gi, '')
	const city = (typeof query.city !== 'undefined' ? query.city as string : '').replace(/[`~!@#$%^*()_|+\-=?;:'".<>\{\}\[\]\\\/]/gi, '')
	const category = (typeof query.category !== 'undefined' ? query.category as string : '').replace(/[`~!@#$%^*()_|+\-=?;:'".<>\{\}\[\]\\\/]/gi, '')
	const occupation = (typeof query.occupation !== 'undefined' ? query.occupation as string : '').replace(/[`~!@#$%^*()_|+\-=?;:'".<>\{\}\[\]\\\/]/gi, '')
	const jobType = (typeof query.jobType !== 'undefined' ? query.jobType as string : '').replace(/[`~!@#$%^*()_|+\-=?;:'".<>\{\}\[\]\\\/]/gi, '')

	interface Filters {
		layout: string,
		page: number,
		keyword: string,
		mrt: string[],
		city: string[],
		category: string[],
		occupation: string[],
		jobType: string[]
	}

	const filters: Filters = {
		layout: (typeof query.layout !== 'undefined' ? query.layout as string : '').replace(/[`~!@#$%^*()_|+\-=?;:'".<>\{\}\[\]\\\/]/gi, ''),
		page: (typeof query.page !== 'undefined' && parseInt(query.page as string)) ? parseInt(query.page as string) : 1,
		keyword: (typeof query.keyword !== 'undefined' ? query.keyword as string : '').replace(/[`~!@#$%^*()_|+\-=?;:'".<>\{\}\[\]\\\/]/gi, ''),
		mrt: mrt.split(',').filter((el) => {
			return el !== ''
		}),
		city: city.split(',').filter((el) => {
			return el !== ''
		}),
		category: category.split(',').filter((el) => {
			return el !== ''
		}),
		occupation: occupation.split(',').filter((el) => {
			return el !== ''
		}),
		jobType: jobType.split(',').filter((el) => {
			return el !== ''
		})
	}

	// const session: any = req.session
	// const user = session.user // { ... } || undefined

	const client = createClient({
		endpoint: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT as string,
		headers: {
			'X-Hasura-Admin-Secret': process.env.HASURA_ADMIN_SECRET as string
		}
	})
	const hasuraQuery = await client.query({
		query: `
      query ($date: timestamptz!, $country: String) {
        Occupation(order_by: {name: asc}) {
          id
          name
          nameChinese
          nameMalay
          industry
        }
				Category(order_by: {name: asc}) {
          id
          name
        }
        MrtStation {
          id
          name
          nameChinese
        }
        Event(where: {
          startDate: {_lte: $date}
          endDate: {_gte: $date}
        } order_by: {startDate: desc}) {
          banner
          startDate
          id
          name
          featured
        }
        MrtLine {
          id
          name
          nameChinese
          colour
          MrtStations {
            id
            name
            nameChinese
          }
        }
				State {
					id
					name
					country
					Cities {
						id
						name
					}
				}
				City {
					id
					name
				}
				${company !== 0 ? `Company(where: {id: {_eq: ${company}}}){ name }` : ''}
				Advertisements(
						where: {
							_and: {
								isActive: { _eq: true }
								adsType: {_in: [WEBBANNER,WEBBANNERPOPUP]}
								startAt: { _lte: $date }
								country: {_eq: $country}
								_or: [{ endAt: { _gte: $date } }, { endAt: { _is_null: true } }]
							}
						}, order_by: {id: desc}
					) {
						id
						imageUrl
						param
						name
						isActive
						startAt
						adsType
					}
      }
    `,
		variables: {
			date: new Date(),
			country: locale?.toUpperCase()
		}
	}) 

	const { data } = hasuraQuery
	const { Occupation, Category, Event, MrtLine, MrtStation, State, City } = data

	const apiUrl = `${process.env.NEXT_PUBLIC_API_ENDPOINT}v1/jobseeker/job?country=${locale?.toUpperCase()}&page=${filters.page}&keyword=${filters.keyword}&mrt=${filters.mrt}&city=${filters.city}&type=${filters.jobType}&category=${filters.category}&occupation=${filters.occupation}`
	// Fetch data from external API
	const res = await fetch(apiUrl)
	const jobsData = await res.json()

	const jobs = jobsData.rows
	const jobAggregate = jobsData.count

	for (let i=0; i<jobs.length; i++) {
		jobs[i].Mrt = jobs[i].JobLocations.filter((jl: any) => {
			return jl.MrtStation !== null
		})

		jobs[i].City = jobs[i].JobLocations.filter((jl: any) => {
			return jl.City !== null
		})
	
		jobs[i].JobLocations = jobs[i].JobLocations.filter((jl: any) => {
			return jl.Branch !== null
		})
	}

	let Company = null
	if (data.Company) {
		Company = data.Company
	}

	const currentPage = filters.page
	interface Pagination {
		prev: boolean,
		pagi: (number | string)[],
		next: boolean
	}
	const pagination: Pagination = {
		prev: false,
		pagi: [],
		next: false
	}
	// pagination.prev = false
	if (currentPage > 1) {
		pagination.prev = true
	}

	const numOfPage = Math.ceil(jobAggregate / 10)
	pagination.pagi = []

	if (numOfPage < 6) {
		pagination.pagi = Array.from(Array(numOfPage), (e, i) => { return i + 1 })
	} else {
		if (currentPage < 3) {
			pagination.pagi = Array.from(Array(3), (e, i) => { return i + 1 })
			pagination.pagi.push('dotted')
			pagination.pagi.push(numOfPage)
		} else {
			const tempPagiItems: (number | string)[] = []

			if (currentPage - 1 > 1) {
				if (currentPage - 2 !== 1) {
					tempPagiItems.push(1)
					if (currentPage - 2 !== 1) {
						tempPagiItems.push('dotted')
					}
				}
				// tempPagiItems.push(currentPage - 2)
			}

			if (currentPage - 1 > 1) {
				tempPagiItems.push(currentPage - 1)
			}

			tempPagiItems.push(currentPage)
			if (currentPage + 1 <= numOfPage) {
				tempPagiItems.push(currentPage + 1)
			}
			if (currentPage + 2 <= numOfPage) {
				// tempPagiItems.push(currentPage + 2)
				if (currentPage + 2 !== numOfPage) {
					if (currentPage + 3 < numOfPage) {
						tempPagiItems.push('dotted')
					}
					tempPagiItems.push(numOfPage)
				}
			}

			pagination.pagi = tempPagiItems
		}
	}

	if (currentPage < numOfPage) {
		pagination.next = true
	}

	// combine ads and events into one list
	const eventsFormatted = Event.map(event=>{
		return {
			...event,
			type: 'Event'
		}
	})
	
	const adsFormatted = process.env.NEXT_PUBLIC_SITE_NAME === 'findjobs' ? 
		data.Advertisements.filter(ad => ad.adsType === 'WEBBANNER').map(ad=>{
			return {
				id:ad.id,
				banner: ad.imageUrl,
				param: ad.param,
				name: ad.name,
				featured: false,
				startDate: ad.startAt,
				isActive: ad.isActive,
				type: 'Ads'
			}
		}) : []

	const webBannerPopup = process.env.NEXT_PUBLIC_SITE_NAME === 'findjobs' ? 
		data.Advertisements.filter(ad => ad.adsType === 'WEBBANNERPOPUP').map(ad=>{
			return {
				id:ad.id,
				banner: ad.imageUrl,
				param: ad.param,
				name: ad.name,
				featured: true,
				startDate: ad.startAt,
				isActive: ad.isActive,
				type: 'Ads'
			}
		}) : []

	const adsAndEvents = eventsFormatted.concat(adsFormatted)

	const popUpBanners = locale?.toUpperCase() === 'SG' ? eventsFormatted.concat(webBannerPopup) : webBannerPopup

	//make ads display in mobile view like a carousel
	const getMobileAdsPerPage = () => {
		//repeat mobile ads x times
		const repeatArrayXTimes = (arr, repeats) => [].concat(...Array.from({ length: repeats }, () => arr))
		const sgAdsAndEvents = adsAndEvents
		const malaysiaAds = adsFormatted
		const sgOrMalaysiaArray = locale?.toUpperCase() === 'SG' ? sgAdsAndEvents : malaysiaAds
		const adsAndEventsCarousel = repeatArrayXTimes(sgOrMalaysiaArray, numOfPage)

		const mobileAdsOnEachPage:Array<{
		page:number
		ads:Array<{
			id: number
    	banner: string
    	param: string
    	name: string
    	featured: boolean,
    	startDate: string
   		isActive: boolean,
   		type: string
		}>
	}> = []

		const adsPerPage = 4
		let page = 1

		//page 1 have first 4 ads, page 2 have next 4...
		for(let i=0;i<adsPerPage*numOfPage;i+=4){
			const adsAndEvents = adsAndEventsCarousel.slice(i,i+4)
			mobileAdsOnEachPage.push(
				{
					page: page,
					ads: adsAndEvents
				}
			)
			page++
		}
		return mobileAdsOnEachPage
	}
	const mobileAdsOnEachPage = getMobileAdsPerPage()
	
	return {
		props: {
			...(await serverSideTranslations(locale as string, ['common'])),
			// Will be passed to the page component as props
			filters: filters,
			jobs: jobs,
			jobAggregate: jobAggregate,
			Occupation: Occupation.map((occup) => {
				const tempOccup = occup
				const tempIndustry = occup.industry !== null ? occup.industry.split(',').map(x => parseInt(x)) : occup.industry
				tempOccup.industry = tempIndustry
				return tempOccup
			}),
			Category: Category,
			adsAndEvents: adsAndEvents,
			pagination: pagination,
			mrtLine: MrtLine,
			state: State,
			city: City,
			MrtStation: MrtStation,
			Company: Company,
			redirectedFromMPS: typeof req.headers.referer !== 'undefined' ? req.headers.referer.includes('?source=MPS') : false,
			mobileAdsOnCurrentPage: mobileAdsOnEachPage?.length ? mobileAdsOnEachPage[currentPage-1].ads : [],
			malaysiaAds: adsFormatted,
			popUpBanners: popUpBanners
		}
	}
}, sessionOptions
)

export default BrowseJobs
